import React from 'react';
import { createRoot } from 'react-dom/client';
import { initRelatedTagsRenderer } from '../ts/components/related-tags/RelatedTagsRenderer';
import getRelatedTagsView from '@hooks/relatedTagsView';
import { readTagArticlesBootstrap } from '../ts/components/tag-articles/tagArticlesBootstrap';
import { TagArticlesIsland } from '../ts/components/tag-articles/TagArticlesIsland';
/**
 * Default hook for the TAG page type.
 *
 * 1. Initialises the related-tags renderer (new hook-driven approach).
 * 2. Mounts the tag articles React island into #tag-articles-root.
 *
 * To override, create: projects/<id>/ui/hooks/onTag.ts
 */
export default async function onTag(_context) {
    const contract = getRelatedTagsView();
    await initRelatedTagsRenderer(contract);
    const bootstrap = readTagArticlesBootstrap();
    if (!bootstrap)
        return;
    const container = document.getElementById('tag-articles-root');
    if (!container)
        return;
    const root = createRoot(container);
    root.render(React.createElement(TagArticlesIsland, { bootstrap }));
}
